<template lang="pug">
  
  div
    .logo.text-center: img(src="~@/assets/logo.png")
    .middle-box.text-center.loginscreen.animated.fadeInDown
      div
        br
        .bg-danger.p-xs.b-r-sm(v-show="failText") {{ failText }}
        form.m-t(role="form" v-on:submit.prevent="onSubmit")
          .form-group
            input.form-control.input-lg(type="text" placeholder="Username" v-model="user.username" required)
          .form-group
            input.form-control.input-lg(type="password" placeholder="Password" v-model="user.password" required)
          button.btn.btn-primary.block.full-width.m-b(type="submit")
            span(v-show="!isLogingIn") Login
            i.fa.fa-spinner.fa-pulse.fa-fw(v-show="isLogingIn")
          //- router-link(to="/").btn.btn-primary.block.full-width.m-b Login

</template>

<script>
  import axios from 'axios'
  import $ from 'jquery'

  export default {
    data () {
      return {
        user: {},
        isLogingIn: false,
        failText: ''
      }
    },
    beforeCreate () {
      if (this.$ls.get('token', false)) {
        axios.defaults.headers.common['Authorization'] = this.$ls.get('token')
        this.$router.push('/')
      }
    },
    mounted () {
      $('body').addClass('gray-bg')
    },
    destroyed () {
      $('body').removeClass('gray-bg')
    },
    methods: {
      onSubmit () {
        this.isLogingIn = true
        axios.post('user/login', this.user).then((res) => {
          switch (res.data.responseCode) {
            case 200:
              this.$ls.set('user', res.data.user)
              this.$ls.set('token', res.data.token)
              axios.defaults.headers.common['Authorization'] = res.data.token
              this.$router.push('/')
              break
            default:
              this.failText = res.data.message
          }
          this.isLogingIn = false
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .logo-name {
    color: #1ab394;
  }

  .middle-box {
    max-width: 20000px;
  }

  .logo {
    margin: 10% 0 0;

    img {
      max-width: 100%;
    }
  }
</style>




// WEBPACK FOOTER //
// login.vue?668bee98